export const theme = {
  colors: {
    primary: '#23212b',
    secondary: '#3e4651',
    red: '#dd5152',
    blue: '#37b1e3',
    green: '#2cc990',
    yellow: '#ffa400',
    darkFont: '#222222',
    midFont: '#555555',
    midGrey: '#3e4651',
    white: '#ffffff',
    black: '#000000',
  },
  size: {
    maxColumnWidth: '40rem',
    minColumnWidth: '15rem',
  },
  breakpoints: {
    tablet: '48rem',
  },
}
